export const RunStates = {
    NOT_RUN: 'Not run',
    RUNNING: 'Running',
    COMPLETE: 'Complete',
    TIMED_OUT: 'Timed out',
    FAILED: 'Failed'
}
